import { TrackingConfig } from '@keatech/tracking';
import { environment } from '~environment';

export const TRACKING_CONFIG: TrackingConfig = {
    aiConnectionString: environment.aiConnectionString,
    version: environment.version,
    serverBaseUrl: environment.serverBaseUrl,
    isSupportedBrowser: environment.isSupportedBrowser,
};
